// extracted by mini-css-extract-plugin
export default {"sectionBourseMarket":"style_sectionBourseMarket__SbqRr"};